import React, {
  Component
} from "react";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import Modal from "../Modal";
import * as modal from "../../reducers/modalReducer";
import RaisedButton from "material-ui/RaisedButton";
import styled from "styled-components";
import {
  BODY_TEXT_COLOR,
  NEGATIVE_COLOR
} from "../../config/colors";
import {
  HeaderDiv,
  TextDiv
} from "../../modals";

const styles = {
  button: { marginTop: 15, fontWeight: 700 },
  secondaryButtonColor: NEGATIVE_COLOR,
  labelStyle: { fontWeight: 700 }
};

class ConfirmModal extends Component {
  modalStyle = {border: `3px solid #${this.props.secondaryColor}`, maxWidth: '600px'};
  secondaryColor = ["#", this.props.secondaryColor].join("");

  onCloseRequest = () => {
    if (this.state.handleNegativeClick) return;
    this.props.hideModal();
  };

  handlePositiveClick = () => {
    this.props.confirm();
  };

  handleNegativeClick = () => {
    if (this.props.cancel) {
      this.props.cancel();
    }
  };

  getButtonStyle = () => ({...styles.button, ...this.props.buttonStyle });

  render() {
    const {
      title,
      message,
      confirmText,
      cancelText,
      hideCancel,
    } = this.props;

    return (
      <Modal
        style={this.modalStyle}
        overlayTop={0}
        closeOnOutsideClick={false}
        isOpened={true}
        onClose={this.onCloseRequest}
      >
        <ModalWrapperDiv>
          <HeaderDiv>{title}</HeaderDiv>

          <TextDiv>
            <div>
              {message}
            </div>
          </TextDiv>

          <ButtonsWrapperDiv>
            <RaisedButton
              onClick={this.handlePositiveClick}
              backgroundColor={this.secondaryColor}
              labelColor="#FFF"
              labelStyle={styles.labelStyle}
              label={`${confirmText ? confirmText : 'Yes'}`}
              style={this.getButtonStyle()}
            />
            {!hideCancel
              && (
                <RaisedButton
                  onClick={this.handleNegativeClick}
                  backgroundColor={styles.secondaryButtonColor}
                  labelColor="#FFF"
                  label={`${cancelText ? cancelText : 'No'}`}
                  labelStyle={styles.labelStyle}
                  style={this.getButtonStyle()}
                />
              )
            }
          </ButtonsWrapperDiv>
        </ModalWrapperDiv>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    secondaryColor: state.config.secondaryColor
  };
};

const mapDispatchToProps = dispatch => {
  return {
    hideModal: () => dispatch(modal.hideModal())
  };
};

ConfirmModal.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string.isRequired,
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
  confirm: PropTypes.func.isRequired,
  cancel: PropTypes.func,
  hideCancel: PropTypes.bool.isRequired,
  buttonStyle: PropTypes.shape({}),
};

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmModal);

const ModalWrapperDiv = styled.div`
  display: flex;
  color: ${BODY_TEXT_COLOR};
  flex-direction: column;
  font-size: 18px;
  align-items: center;
  justify-content: center;
  margin: 20px auto 20px;
  height: 100%;
  padding: 0 35px;
  @media (max-width: 768px) {
    padding: 0 25px;
  }
`;

const ButtonsWrapperDiv = styled.div`
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  width: 100%;
  @media (max-width: 768px) {
    width: 355px;
    align-items: center;
    & > div {
      margin-bottom: 5px;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/ConfirmModal/ConfirmModal.jsx